export default __webpack_public_path__ + "static/media/warning-filled.cfff2a11.svg";